import type { BrandConfig } from './types';

import { kkConfig } from './kk';
import { pacConfig } from './pac';

// __APP_BRAND__ is replaced at build time by Vite's `define` option.
// Vite/Rollup dead-code-eliminates the unused branch in production builds.
// eslint-disable-next-line no-undef
const brandConfig: BrandConfig = __APP_BRAND__ === 'pac' ? pacConfig : kkConfig;

export { brandConfig };
export type { Brand, BrandConfig, BrandVisibility } from './types';
